import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { FaPause, FaSortDown, FaSortUp } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Modal from '../../../components/UI/Modal/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Box from '../../../hoc/Box/Box';
import { sortDataByProperty } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import classes from './GroupDevices.css';

class GroupDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceMacs: new Map(),
      action: '',
      result: null,
      confirmModal: false,
      upArrow: true,
      currentRecords: this.buildDeviceGroupData(this.props.devices, this.props),
      sortBy: 'deviceSignalStatus',
      sortDirection: 'asc',
    };
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.loading !== this.props.loading) {
      this.setState({
        currentRecords: null,
        sortDirection: 'asc',
      });
    }

    if (
      !this.state.currentRecords &&
      nextProps.devices &&
      nextProps.devices.length
    ) {
      this.setState(
        {
          currentRecords: this.buildDeviceGroupData(
            nextProps.devices,
            nextProps
          ),
          sortDirection: 'asc',
        },
        () => {
          this.sortTable('deviceSignalStatus');
        }
      );
    }
  }

  componentDidMount() {
    this.setState(
      {
        currentRecords: this.buildDeviceGroupData(
          this.props.devices,
          this.props
        ),
        sortDirection: 'asc',
      },
      () => {
        this.sortTable('deviceSignalStatus');
      }
    );
  }

  componentDidUpdate() {
    if (this.state.currentRecords === null) {
      this.setState(
        {
          currentRecords: this.buildDeviceGroupData(
            this.props.devices,
            this.props
          ),
          sortDirection: 'asc',
        },
        () => {
          this.sortTable('deviceSignalStatus');
        }
      );
    }
  }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  resetUpArrow() {
    this.setState({
      upArrow: false,
    });
  }

  handleRemoveDeviceCheckBox = (e) => {
    let deviceMac = e.target.value;
    let checked = e.target.checked;
    let deviceMacs = this.state.deviceMacs;
    if (deviceMacs.get(deviceMac) && !checked) {
      deviceMacs.delete(deviceMac);
    } else {
      deviceMacs.set(deviceMac, checked);
    }
    this.setState({
      deviceMacs,
    });
  };

  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };

  confirmModalConfirmHandler = () => {
    const { groupDetails } = this.props;
    let selectedMacs = [];
    groupDetails.devices.forEach((device) => {
      selectedMacs.push(device.mac);
    })
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        selectedMacs = selectedMacs.filter(item => item !== mac);
      }
    });
    let payload = {
      grpAssignedDevices: selectedMacs,
      grpName: groupDetails.nickname,
      grpIcon: groupDetails.imageId,
      grpId: groupDetails.id,
      type: 'assignDevice',
    };

    this.props.changeDeviceGroupDetails(payload);

    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = (e) => {
    this.setState({ confirmModal: false, deviceMacs: new Map() });
    if (e === 'close') {
    }
  };

  removeDeviceHandler = (e) => {
    let selectedDeviceNames = '';

    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        this.props.devices.forEach((data) => {
          if (data.mac === mac) {
            selectedDeviceNames += this.getDeviceName(data) + ' ,';
          }
        });
      }
    });
    selectedDeviceNames = selectedDeviceNames.slice(0, -1);
    const modalContent = (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h2>Remove Device</h2>
        <p style={{ fontWeight: 'normal', textAlign: 'center', margin: 0 }}>
          Devices being removed from group will lose their pause schedule if one
          exists.
        </p>
        <p style={{ fontWeight: 'normal', textAlign: 'center', margin: 0 }}>
          Are you sure you want to remove the selected devices from this group?
        </p>
      </div>
    );
    this.onOpenModal(modalContent);
  };
  getDeviceName = (device) => {
    let deviceName;
    if (
      !device.nickname ||
      device.nickname === undefined ||
      (device.nickname && !device.nickname.length) ||
      device.nickname === null
    ) {
      deviceName = device.name;
    } else {
      if (device.nickname.indexOf('|') !== -1) {
        deviceName = device.nickname.slice(
          device.nickname.indexOf('|') + 1,
          device.nickname.length
        );
      } else deviceName = device.nickname;
    }

    if (deviceName === undefined || deviceName.length === 0) {

      if (device.mac) {
        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          if (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel']
            && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
            deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] : '');
          }
        }
        if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['dhcpHostname'];
        }
        if (deviceName === undefined || deviceName.length === 0) {
          deviceName = device.mac;
        };
      }
      if (deviceName === undefined || deviceName.length === 0) {
        deviceName = "Unknown";
      }
    }
    return deviceName;
  };
  getDeviceModel = (device) => {
    const { advancedDeviceIds } = this.props;
    if (!advancedDeviceIds) {
      return 'N/A';
    }
    let adid = advancedDeviceIds[device.mac] || {};
    if (!adid.advancedDeviceId) {
      return 'N/A';
    }
    return adid.advancedDeviceId.model;
  };
  getSignalStatus = (element) => {
    let deviceSignalStatus = 'Disconnected';
    let status,
      paused = 'unpaused';
    if (element && element.freeze.frozen === true) {
      paused = 'paused';
    }
    if (element.health && element.health.status) {
      status =
        element.health.status.charAt(0).toUpperCase() +
        element.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.freeze.frozen === true
    ) {
      status = 'Paused';
      deviceSignalStatus = 'Paused';
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.capabilities
    ) {
      deviceSignalStatus = status;
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      !element.capabilities
    ) {
      deviceSignalStatus = status;
    }
    return { deviceSignalStatus, paused };
  };

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    const records = sortDataByProperty(currentRecords.map(this.getMaskedData), propertyName, sortDirection);
    this.setState({
      currentRecords: records,
      sortDirection:
        sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName,
    });
  };

  buildDeviceGroupData(devices = [], nextProps) {
    return devices.map((device) => {
      const { deviceSignalStatus, paused } = this.getSignalStatus(device);
      device.deviceName = this.getDeviceName(device);
      device.currentGroup = nextProps.currentGroup;
      device.deviceModel = this.getDeviceModel(device);
      device.deviceSignalStatus = deviceSignalStatus;
      device.paused = paused;
      return device;
    });
  }

  renderRowData(type, showOneColumn) {
    const { currentGroup, showDeviceHandler } = this.props;
    const devices = this.state.currentRecords || [];
    if (!devices.length && showDeviceHandler === 'remove') {
      return (
        <td colSpan="5" style={{ textAlign: 'center', color: 'grey' }}>
          No Available device can be removed at this time
        </td>
      );
    } else if (!devices.length) {
      return (
        <td colSpan="5" style={{ textAlign: 'center', color: 'grey' }}>
          There are no devices assigned to this group
        </td>
      );
    }
    return devices.map((data) => {
      const {
        colorDot,
        paused,
        status,
        statusColor,
        statusClass,
        deviceName,
        deviceModel
      } = this.getMaskedData(data);

      return (
        <tr>
          {(type === 'Desktop' || showOneColumn) && (
            <td
              className={classes.DeviceColumnStyle}
              style={{ alignItems: 'center' }}
            >
              {showDeviceHandler === 'remove' && (
                <input
                  type="checkbox"
                  id="removeDeviceCheckbox"
                  className={classes.DeviceCheckBox}
                  checked={this.state.deviceMacs.get(data.mac) || false}
                  name={data.mac}
                  value={data.mac}
                  onClick={this.handleRemoveDeviceCheckBox}
                />
              )}
              <span
                id="DeviceName"
                className={classes.GroupDevicesWrapText}
                style={{ marginLeft: '10px' }}
              >
                {' '}
                {deviceName}
              </span>
            </td>
          )}
          {!showOneColumn && <td id="Signal">{colorDot}</td>}
          {!showOneColumn && (
            <td id="DeviceModel" style={{ width: '100px' }}>
              <span
                style={{
                  wordWrap: 'normal',
                  display: 'block',
                  width: '235px',
                  whiteSpace: 'normal',
                }}
              >
                {deviceModel}
              </span>
            </td>
          )}
          {!showOneColumn && (
            <td id="CurrentGroup" style={{ whiteSpace: 'pre' }}>
              {currentGroup}
            </td>
          )}
          {!showOneColumn && <td id="Paused" style={{ textAlign: 'center' }}>{paused}</td>}
        </tr>
      );
    });
  }

  getMaskedData = (data) => {
    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: 'red',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
      paused: '#ffb347',
      notavailable: 'red',
    };
    let status;
    if (data.health && data.health.status) {
      status =
        data.health.status.charAt(0).toUpperCase() +
        data.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }

    let paused = '';
    if (data.freeze.frozen === true) {
      paused = <FaPause id="Pause" color={'gray'} />;
    }
    let statusColor, statusClass;
    if (status === 'N/A') {
      statusColor = { color: 'red' };
      statusClass = classes.poor;
    } else {
      statusColor = {
        color: data.health
          ? colorCode[data.health.status]
          : colorCode.disconnected,
      };
      statusClass = data.health
        ? classes[data.health.status]
        : classes.disconnected;
    }
    let colorDot;
    if (data.deviceSignalStatus === 'Calculating') {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.Calculating}></div>
          <div style={{ width: '10px' }} />
          <div style={{ color: colorCode.calculating }}>{status}</div>
        </div>
      );
    } else if (
      data.connectionState &&
      data.connectionState === 'connected' &&
      data.freeze.frozen === true
    ) {
      status = 'Paused';
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.Paused}></div>
          <div style={{ width: '10px' }} />
          <div>Paused</div>
        </div>
      );
    } else if (
      data.connectionState &&
      data.connectionState === 'connected' &&
      data.capabilities
    ) {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div
            className={
              status === 'Poor' || status === 'Fair'? classes.NotConnected : classes.Connected
            }
          ></div>
          <div style={{ width: '10px' }} />
          <div
            style={{
              color: status === 'Poor' || status === 'Fair'? colorCode.poor : colorCode.connected,
            }}
          >
            {status}
          </div>
        </div>
      );
    } else if (
      data.connectionState &&
      data.connectionState === 'connected' &&
      !data.capabilities
    ) {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.NotConnected}></div>
          <div style={{ width: '10px' }} />
          <div styles={{ color: colorCode.disconnected }}>{status}</div>
        </div>
      );
    } else {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.NotConnected}></div>
          <div style={{ width: '10px' }} />
          <div style={{ color: colorCode.poor }}>Disconnected</div>
        </div>
      );
    }
    return {
      ...data,
      colorDot,
      paused,
      status,
      statusColor,
      statusClass,
      deviceName: this.getDeviceName(data),
      deviceModel: this.getDeviceModel(data),
    }
  }

  renderTableInfo(type) {
    let sortIcon;
    const { sortDirection, sortBy, currentRecords } = this.state;
    if (this.props.loading || !this.props.loaded) {
      return <Spinner />;
    }
    if (sortDirection === 'desc') {
      sortIcon = <FaSortUp fontSize={'18px'} />;
    } else if (sortDirection === 'asc') {
      sortIcon = <FaSortDown fontSize={'18px'} />;
    }
    const { showDeviceHandler } = this.props;
    const devices = currentRecords || [];
    if (!devices.length && showDeviceHandler === 'remove') {
      return (
        <div
          colSpan="5"
          style={{ textAlign: 'center', color: 'grey', padding: '20px' }}
        >
          No Available device can be removed at this time
        </div>
      );
    } else if (!devices.length) {
      return (
        <div
          id="NoDevicesText"
          colSpan="5"
          style={{ textAlign: 'center', color: 'grey', padding: '20px' }}
        >
          No device assigned to this group.
        </div>
      );
    }
    if (type === 'Desktop') {
      return (
        <React.Fragment>
          <thead>
            <tr className={classes.trTag}>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceName');
                }}
              >
                Device Name {sortBy === 'deviceName' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceSignalStatus');
                }}
              >
                Signal {sortBy === 'deviceSignalStatus' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceModel');
                }}
              >
                Device Model {sortBy === 'deviceModel' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('currentGroup');
                }}
              >
                Current Group {sortBy === 'currentGroup' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'center',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('paused');
                }}
              >
                Pause {sortBy === 'paused' && sortIcon}{' '}
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData(type)}</tbody>
        </React.Fragment>
      );
    } else {
      let table1 = (
        <div style={{ float: 'left' }}>
          <table
            className={classes.GroupDeviceTable}
            cellPadding="0"
            cellSpacing="0"
          >
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceName');
                  }}
                >
                  Device Name {sortBy === 'deviceName' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderRowData(type, true)}</tbody>
          </table>
        </div>
      );

      let table2 = (
        <div className={classes.tableWrapper}>
          <table
            className={classes.GroupDeviceTable}
            cellPadding="0"
            cellSpacing="0"
          >
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceSignalStatus');
                  }}
                >
                  Signal {sortBy === 'deviceSignalStatus' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceModel');
                  }}
                >
                  Device Model {sortBy === 'deviceModel' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('currentGroup');
                  }}
                >
                  Current Group {sortBy === 'currentGroup' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('paused');
                  }}
                >
                  Pause {sortBy === 'paused' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderRowData(type)}</tbody>
          </table>
        </div>
      );
      return (
        <div style={{ display: 'flex' }}>
          {table1}
          {table2}
        </div>
      );
    }
  }

  getArrow = () => {
    if (this.state.upArrow) {
      return <MdKeyboardArrowUp color={'#0073d1'} size={'30px'} />;
    }
    return <MdKeyboardArrowDown color={'#0073d1'} size={'30px'} />;
  };
  render() {
    const { devices } = this.props;
    return (
      <div className={classes.GroupDevices}>
        <div className={classes.showDesktop}>
          <h3 id="GroupDevices" style={{ margin: '1rem' }}>
            Group Devices
          </h3>
          <div className={classes.tableWrapper}>
            <table
              className={
                devices && devices.length
                  ? classes.GroupDeviceTable
                  : classes.NoDevices
              }
              cellPadding="0"
              cellSpacing="0"
            >
              {this.renderTableInfo('Desktop')}
            </table>
          </div>
          {this.props.showDeviceHandler === 'remove' &&
            this.props.devices.length ? (
            <div>
              <button
                id="removeDeviceButton"
                disabled={!this.state.deviceMacs.size}
                className={classes.ActionButton}
                onClick={() => {
                  this.removeDeviceHandler();
                }}
              >
                Remove
              </button>
            </div>
          ) : null}
        </div>
        <div className={classes.showMobile}>
          <Collapsible
            transitionTime={100}
            open={true}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div className={classes.GroupDevices}>
                  <div className={classes.TitleArea}>
                    <h2
                      style={{
                        margin: '1rem',
                        color: 'black',
                        fontSize: '16px',
                      }}
                    >
                      Group Devices
                    </h2>
                    <button
                      className={classes.OpenCloseButton}
                      aria-label="open arrow"
                    >
                      {this.getArrow()}
                    </button>
                  </div>

                  <div className={classes.HorizontalSeparator} />
                </div>
              </Box>
            }
          >
            {/* /  <h2 style={{margin: '1rem',fontSize: '16px'}}>Group Devices</h2> */}
            <div>
              {this.renderTableInfo('Mobile')}
              {this.props.showDeviceHandler === 'remove' &&
                this.props.devices.length ? (
                <div>
                  <button
                    disabled={!this.state.deviceMacs.size}
                    className={classes.ActionButton}
                    onClick={() => {
                      this.removeDeviceHandler();
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : null}
            </div>
          </Collapsible>
        </div>
        {this.state.confirmModal && (
          <Modal
            deviceGroupConfirmation="true"
            show={this.state.confirmModal}
            modalClosed={this.confirmModalCancelHandler}
          >
            <Confirm
              id={'RemoveDeviceFromGroupConfirm'}
              deviceGroupConfirmation="true"
              action={this.state.action}
              result={this.state.result}
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              cancelButtonLabel="Cancel"
              confirmButtonLabel="Yes"
            />
          </Modal>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    advancedDeviceIds: state.devices.advancedDeviceIds,
    loading: state.devices.loading,
    loaded: state.devices.loaded,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeDeviceGroupDetails: (payload) =>
      dispatch(actions.changeDeviceGroupDetails(payload)),
    onUnassignDeviceGroup: (deviceGroupId, deviceMacs) =>
      dispatch(actions.unassignDeviceGroup(deviceGroupId, deviceMacs)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupDevices);
